import MergeTypeIcon from '@mui/icons-material/MergeType';
import { ToolsPanelToggleButton } from "../controls";

type MergePositionsAcrossPlatformsToggleButtonProps = {
    isActivated: boolean;
    setIsActivated: React.Dispatch<React.SetStateAction<boolean>>;
};

export function MergePositionsAcrossPlatformsToggleButton({
    isActivated,
    setIsActivated,
}: MergePositionsAcrossPlatformsToggleButtonProps) {
    return (
        <ToolsPanelToggleButton
            isActivated={isActivated}
            setIsActivated={setIsActivated}
            tooltipTextWhenActivated="Show positions separately by platform"
            tooltipTextWhenDeactivated="Merge positions across platforms"
        >
            <MergeTypeIcon
                sx={{
                    height: '18px',
                    width: '18px',
                }}
            />
        </ToolsPanelToggleButton>
    );
}
